<template>
    <div class="myTab">
      <div class="tab" @click="onChange(1)">
        <div class="circular" :class="tabActive === 2 ? 'complete' : ''">
          <img src="@/assets/images/checkMark.png" alt="" v-if="tabActive === 2" class="checkMark">
          <span v-else>1</span>
        </div>
        <div class="tabText">信息认证</div>
      </div>
      <div class="line"></div>
      <div class="tab" @click="onChange(2)">
        <div class="circular" :class="tabActive === 1 ? 'grey' : ''">2</div>
        <div class="tabText">资料填写</div>
      </div>

    </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      
    };
  },
  created() {
  },
  computed: {
    ...mapState({
      tabActive(val) {
        return val.publicPage.tabActive;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    onChange(e) {
      if (e === 1) {
        this.updateState({
          tabActive: e,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .myTab {
    height: 78px;
    background: #FFFFFF;
    margin-top: 4px;
    display: flex;
    padding: 0 28px;
    justify-content: space-between;
    position: relative;
    border-bottom: 1px solid #CED4DB;
    .tab {
      flex: 0 0 48px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #2F3133;
      line-height: 36px;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      .circular {
        background: #FF6538;
        width: 24px;
        height: 24px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 500;
        border-radius: 50%;
        text-align: center;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        .checkMark {
          height: 13px;
        }
      }
      .grey {
        background: #D8D8D8;
      }
      .complete {
        border: 1px solid #FF6538;
        background: #FFFFFF;
      }
    }
   
    .line {
      height: 2px;
      background: #D8D8D8;
      position: absolute;
      top: 32px;
      left: 68px;
      width: calc(100% - 136px);
    }
    .tabText {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #2F3133;
      line-height: 18px;
      font-weight: 400;
      margin-top: 8px;
    }
  }
</style>
